import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppSidenavItem, AppSidenavSubItem } from "./app-sidenav.data";
import { AppPageService } from "../app-page/app-page.service";
import { AppSidenavService } from "./app-sidenav.service";
import { delay } from "rxjs/operators";

@UntilDestroy()
@Component({
    selector: "ifc-app-sidenav",
    templateUrl: "./app-sidenav.component.html",
    styleUrls: ["./app-sidenav.component.scss"],
    standalone: false
})
export class AppSidenavComponent implements OnInit {
  data: AppSidenavComponentData;
  items = [];
  trackByFn = null;

  constructor(
    private route: ActivatedRoute,
    private appPageService: AppPageService,
    private service: AppSidenavService
  ) {}

  emitItemSelectedEvent() {
  this.appPageService.itemSelectedSubject.next(undefined);
  }

  dataSet(data: AppSidenavComponentData) {
    this.data = data;
    if (this.data?.appSidenav?.items) {
      this.items = this.data.appSidenav.items.filter((it) => !it.hidden);
    }
    if (this.data?.appSidenav?.trackByFn) {
      this.trackByFn = this.data.appSidenav.trackByFn;
    }
  }

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe(this.dataSet.bind(this));
    this.service.itemsChange.pipe(delay(100), untilDestroyed(this)).subscribe((it) => {
      this.items = it.filter((it) => !it.hidden);
    });
  }
}

export interface AppSidenavComponentData {
  appSidenav: {
    items: AppSidenavItem[];
    trackByFn?: (
      index: number,
      item: AppSidenavItem | AppSidenavSubItem
    ) => any;
  };
}
